var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState } from "react";
import styled from "styled-components";
import { DynamicTable, useFlagOnError, useQuery, } from "@atlassiansox/microscopekit";
import cloudFormationLogsQuery from "./cloudformation-events.query.graphql";
import { deploymentStatus, getDeploymentId } from "./utils";
import moment from "moment";
var Lozenge = require("@atlaskit/lozenge").default;
var LogsTabContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 30px;\n  width: 100%;\n"], ["\n  margin-top: 30px;\n  width: 100%;\n"])));
var DateTimeDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])));
export var LogsTab = function (props) {
    var serviceId = props.serviceId, curShard = props.curShard, envRegion = props.envRegion, deploymentType = props.deploymentType, deploymentId = props.deploymentId;
    var _a = useState(true), dateFormat = _a[0], setDateFormat = _a[1];
    var _b = useQuery(cloudFormationLogsQuery, {
        errorPolicy: "all",
        pollInterval: 5000,
        variables: { id: serviceId },
    }), loading = _b.loading, error = _b.error, data = _b.data;
    useFlagOnError({
        title: "Error",
        message: "There was an error retrieving deployment logs.",
        type: "error",
    }, error);
    var getRows = function (data) {
        var _a, _b, _c;
        if (!data) {
            return [];
        }
        var service = data.service;
        var microsV2 = service.microsV2;
        var shard = curShard === "default"
            ? microsV2.shards[0]
            : microsV2.shards.find(function (shard) { return shard.id === curShard; });
        var environment = shard.environments.items.find(function (environment) { return environment.name === envRegion; });
        if (deploymentType === "accountId") {
            return [];
        }
        var deployment = environment.deployments[deploymentType];
        var logs = [];
        if (deploymentType.includes("other") ||
            deploymentType.includes("persistent")) {
            logs = logs.concat.apply([], ((_a = deployment.find(function (d) {
                return getDeploymentId(d.id) === deploymentId;
            }).logs) === null || _a === void 0 ? void 0 : _a.cloudFormation) || []);
        }
        else {
            logs =
                ((_c = (_b = deployment) === null || _b === void 0 ? void 0 : _b.logs) === null || _c === void 0 ? void 0 : _c.cloudFormation) || [];
        }
        return logs.map(function (log, index) { return ({
            key: "row-" + index + "-" + serviceId,
            cells: [
                {
                    key: log.status,
                    content: (React.createElement(Lozenge, { isBold: true, appearance: deploymentStatus(log.status), children: log.status })),
                },
                { key: log.logicalId, content: log.logicalId },
                { key: log.reason, content: log.reason },
                {
                    key: log.timestamp,
                    content: dateFormat ? (React.createElement(DateTimeDiv, { onClick: function () { return setDateFormat(function (dateFormat) { return !dateFormat; }); } }, log.timestamp)) : (React.createElement(DateTimeDiv, { onClick: function () { return setDateFormat(function (dateFormat) { return !dateFormat; }); } }, moment(log.timestamp).fromNow())),
                },
            ],
        }); });
    };
    var rows = getRows(data);
    var head = {
        cells: [
            {
                key: "status",
                content: "Status",
                isSortable: true,
                width: 3,
            },
            {
                key: "logicalId",
                content: "Logical ID",
                isSortable: true,
                width: 3,
            },
            {
                key: "reason",
                content: "Reason",
                isSortable: true,
                width: 3,
            },
            {
                key: "timestamp",
                content: "Timestamp",
                isSortable: true,
                width: 3,
            },
        ],
    };
    return (React.createElement(LogsTabContainer, null,
        React.createElement(DynamicTable, { head: head, rows: rows, isLoading: !data && loading, emptyView: React.createElement("div", null, "No CloudFormation Events to show."), rowsPerPage: 50, defaultSortKey: "timestamp", defaultSortOrder: "DESC", isFixedSize: true })));
};
var templateObject_1, templateObject_2;
